import axios from 'axios';
import { BASE_URL, OCTOPUS_BASE_URL } from '.';

export const getRegions = () => {
    const query = {
        limit: '50',
        skip: '0',
        isBlocked: 'false',
        isDeleted: 'false',
    };
    const queryParam = new URLSearchParams(query);
    return axios.get(`${OCTOPUS_BASE_URL}/regions?${queryParam.toString()}`);
};

export const addRegion = (data: any) => (
    axios.post(`${OCTOPUS_BASE_URL}/regions`, data)
);

export const editRegion = (data: any) => axios.patch(`${OCTOPUS_BASE_URL}/regions/${data.region_id}`, data);

export const deleteRegion = (id: string) => axios.delete(`${OCTOPUS_BASE_URL}/regions/${id}`);

/**
 * Get regions within the current map viewport bounds.
 */
export interface GetRegionsByViewportParams {
    northEastLat: number;
    northEastLng: number;
    southWestLat: number;
    southWestLng: number;
    limit?: number;
}

export const getRegionsByViewport = (params: GetRegionsByViewportParams) => {
    const query: Record<string, string> = {
        northEastLat: String(params.northEastLat),
        northEastLng: String(params.northEastLng),
        southWestLat: String(params.southWestLat),
        southWestLng: String(params.southWestLng),
    };
    if (typeof params.limit === 'number') {
        query.limit = String(params.limit);
    }
    const queryParam = new URLSearchParams(query);
    return axios.get(`${OCTOPUS_BASE_URL}/regions/viewport?${queryParam.toString()}`);
};
